export enum PlaceholderKey {
  GlobalTop = 'global.top',
  GlobalBottom = 'global.bottom',
  HomepageTop = 'home_page.top',
  HomepageBottom = 'home_page.bottom',
  BookingReservationDurationTop = 'booking.reservation.duration.top',
  BookingReservationDurationBottom = 'booking.reservation.duration.bottom',
  BookingReservationLockerTypeTop = 'booking.reservation.locker_type.top',
  BookingReservationLockerTypeBottom = 'booking.reservation.locker_type.bottom',
  BookingRentalDurationTop = 'booking.rental.duration.top',
  BookingRentalDurationBottom = 'booking.rental.duration.bottom',
  BookingRentalLockerTypeTop = 'booking.rental.locker_type.top',
  BookingRentalLockerTypeBottom = 'booking.rental.locker_type.bottom',
  ShoppingCartTop = 'shopping_cart.top',
  ShoppingCartBottom = 'shopping_cart.bottom',
  OrderRentalDetailsTop = 'order.rental_details.top',
  OrderRentalDetailsBottom = 'order.rental_details.bottom',
  OrderReservationDetailsTop = 'order.reservation_details.top',
  OrderReservationDetailsBottom = 'order.reservation_details.bottom',
  OrderMyOrdersTop = 'order.my_orders.top',
  OrderMyOrdersBottom = 'order.my_orders.bottom',
  ReservationPickupTop = 'reservation.pickup.top',
  ReservationPickupBottom = 'reservation.pickup.bottom',
}

export enum EContentBlockPosition {
  Top = 'top',
  Bottom = 'bottom',
}
export type ContentBlockMap = Partial<
  Record<EContentBlockPosition, PlaceholderKey[]>
>
